import theme from '@styles/theme';

export default {
  menuContainer: (isVisible: boolean) => ({
    height: '100vh',
    minHeight: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: `${!isVisible ? 0 : '100%'}`,
    maxWidth: '100vw',
    display: ['flex', 'flex', 'flex', 'flex', 'none'],
    flexDirection: 'column',
    background: theme.rawColors.neutralWhite,
    overflow: 'hidden',
    transition: 'width 0.45s',
    transitionTimingFunction: 'cubic-bezier(.54, 0, .58, 1)',
    zIndex: theme.zIndex.barMenu,
    WebkitTransform: 'translateZ(0)',
    transform: 'translateZ(0)',
    touchAction: 'none',
    WebkitOverflowScrolling: 'touch',
    // Safari iOS fix for viewport height
    '@supports (height: 100svh)': {
      height: '100svh',
      minHeight: '100svh',
    },
  }),
  menuContainerOuter: (isVisible: boolean) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: isVisible ? 1 : 0,
    display: 'flex',
    flexDirection: 'column',
    width: `${isVisible ? '100%' : 0}`,
    maxWidth: '100vw',
    transition: 'opacity .3s ease-out',
    transitionDelay: '.3s',
    height: '100vh',
    minHeight: '100vh',
    overflow: 'hidden',
    touchAction: 'none',
    // Safari iOS fix for viewport height
    '@supports (height: 100svh)': {
      height: '100svh',
      minHeight: '100svh',
    },
  }),
  menuContainerHead: {
    height: ['60px', '60px', '60px', '40px'],
  },
  menuContainerInner: (isVisible: boolean) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: isVisible ? '16px 30px 30px 30px' : 0,
    width: `${isVisible ? '100%' : 0}`,
    maxWidth: '100vw',
    overflowX: 'hidden',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    boxSizing: 'border-box',
    WebkitTransform: 'translateZ(0)',
    transform: 'translateZ(0)',
    touchAction: 'pan-y',
  }),

  productsContainer: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: ['0', '0', '0', '0', '24px', '32px', '40px'],
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-y',
  },
  productMenuContainer: {
    listStyle: 'none',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    paddingRight: ['0', '0', '0', '0', '24px', '32px', '40px'],

    '&:last-of-type': {
      paddingRight: 0,
    },
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-y',
  },
  products: {
    listStyle: 'none',
    paddingRight: ['0', '0', '0', '0', '24px', '32px', '40px'],

    '&:last-of-type': {
      paddingRight: 0,
    },
  },
  productMenuItem: {
    button: {
      fontFamily: theme.fonts.uniformMedium,
      fontWeight: theme.fontWeights.medium,
      fontSize: '20px',
      color: theme.rawColors.darkGrey700,
      lineHeight: '140%',
      textTransform: 'uppercase',
      paddingBottom: '16px',
    },
  },
  inspirationContainer: {
    marginTop: '32px',
  },
  mainPanel: {
    marginTop: '62px',
  },
  inspirationMenuItem: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    fontSize: '20px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    textTransform: 'uppercase',
    paddingBottom: '16px',
  },
  brandNavContainer: {
    marginTop: '32px',
  },
  brandItem: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.text,
    lineHeight: '22px',
    letterSpacing: theme.letterSpacings.smallCaps,
    color: theme.rawColors.darkGrey700,
    textTransform: 'uppercase',
    paddingBottom: '16px',
  },
  closeIconButton: {
    position: 'absolute',
    right: '24px',
    top: '20px',
    alignSelf: 'flex-end',
    zIndex: theme.zIndex.barMenu + 1,
  },
  marketingButton: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 'auto',
    width: '100%',
    marginBottom: '40px',
  },
  marketingTopContentContainer: {
    pb: 20,
  },
  marketingTopContent: {
    display: 'flex',
    alignItems: 'flex-start',
    pb: 20,
    span: {
      fontFamily: theme.fonts.uniformMedium,
      fontWeight: theme.fontWeights.medium,
      fontSize: theme.fontSizes.text,
      letterSpacing: theme.letterSpacings.bigCaps,
      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  marketingButtonContent: {
    whiteSpace: 'nowrap',
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.medium,
    fontStyle: 'normal',
    letterSpacing: theme.letterSpacings.bigCaps,
    lineHeight: '140%',
    textTransform: 'capitalize',
  },
  marketingHeaderContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: '40px',
  },
  marketingContentContainer: {
    overflow: 'hidden',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  marketingProductsTypes: {
    flex: 1,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-y',
  },
  marketingHeader: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    fontSize: '24px',
    lineHeight: '100%',
    color: theme.rawColors.darkGrey700,
    textTransform: 'uppercase',
    width: 'calc(100% - 24px)',
    textAlign: 'center',
  },
  marketingBackButtonContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  productHeader: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    fontSize: '20px',
    lineHeight: '28px',
    color: theme.rawColors.darkGrey700,
    width: 'calc(100% - 24px)',
    textAlign: 'center',
  },
  productItem: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '16px',
    lineHeight: '22px',
    color: theme.rawColors.darkGrey700,
    marginBottom: '12px',
  },
  productsContentContainer: {
    listStyle: 'none',
    display: 'flex',
  },
  loginIconLink: {
    width: '100%',
  },
  navigationHeadContainer: {
    m: '20px 0 20px',
    pb: '16px',
    borderBottom: `1px solid ${theme.rawColors.lightGrey300}`,
    lineHeight: '140%',
    span: {
      color: theme.rawColors.darkGrey300,
      fontSize: theme.fontSizes.smallText,
    },
  },
  navigationFooter: {
    width: '100%',
  },
  userPanelBtn: {
    mb: '24px',
    span: {
      textTransform: 'uppercase',
      position: 'relative',
      display: 'table',
      fontFamily: theme.fonts.uniformMedium,
      fontWeight: theme.fontWeights.medium,
      fontSize: theme.fontSizes.text,
      lineHeight: '22px',
      color: theme.rawColors.darkGrey700,
      '&:hover': {
        cursor: 'pointer',
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          opacity: '1',
          bottom: '-4px',
          height: '1px',
          background: theme.rawColors.darkGrey700,
        },
      },
    },
  },
  backButton: {},
};
